import React, { useState, useContext, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, Row, Col, Container } from 'reactstrap';

import { Text } from '~/components/Text';
import { SubHeader } from '~/components/SubHeader';
import { FiltroBar } from '~/components/Filtros/FiltroBar';
import { verificaPorcentagem } from '~/helpers/price';
import { TransactionsContext } from '../../../../context/TransactionsContext';
import { RecebimentosContext } from '../../../../context/RecebimentosContext';
import { CardDash, CardSplit, CardPrimeDash, CardDashError } from '../Cards';
import TabelaUltimasVendas from '../Tabelas/UltimasVendas';
import TabelaRecebimentos from '../Tabelas/Recebimentos';
import { ModalDetalheVenda } from '../Modais/DetalheVenda';
import { ModalDetalheRecebimento } from '../Modais/DetalheRecebimento';
import { GraficoBandeira } from '../Graficos/Bandeira';
import { GraficoModalidade } from '../Graficos/Modalidade';
import { GraficoTopDias } from '../Graficos/TopDias';
import { GraficoEvolutivo } from '../Graficos/Evolutivo';

function DashboardWeb() {
	const { user } = useSelector((state) => state.auth);
	const {
		transacoes,
		bandeiras,
		modalidade,
		topDias,
		graficoEvolutivo,
		ultimasTransacoes,
		authentication,
	} = useContext(TransactionsContext);
	const { recebimentosCard } = useContext(RecebimentosContext);
	const [modalDetalheVenda, setModalDetalheVenda] = useState(false);
	const [ultimaVenda, setUltimaVenda] = useState({});
	const [modalDetalheRecebimento, setModalDetalheRecebimento] =
		useState(false);
	const [detalheRecebimento, setDetalheRecebimento] = useState({});

	function retornErrorTransacoesHojeOntem() {
		if (transacoes.hoje.error) {
			return true;
		}
		if (transacoes.ontem.error) {
			return true;
		}

		return false;
	}

	function verificaNumero(valor) {
		if (valor !== null) {
			return valor;
		}
		return 0;
	}

	function retornaCreditoPrazo(valorTotal, valorDebito, valorCredito) {
		const total = verificaNumero(valorTotal);
		const debito = verificaNumero(valorDebito);
		const credito = verificaNumero(valorCredito);

		if (!transacoes.hoje.loading || !transacoes.ontem.loading) {
			const prazo = debito + credito;
			return total - prazo;
		}
		return 0;
	}

	function retornaTicketMedio(valorTotal, quantidadeTotal) {
		const total = verificaNumero(valorTotal);
		const quantidade = verificaNumero(quantidadeTotal);
		if (total === 0 && quantidade === 0) {
			return 0;
		}
		return total / quantidade;
	}

	const toggleModalDetalheVenda = useCallback(() => {
		setModalDetalheVenda((oldValue) => !oldValue);
	}, []);

	const toggleModalDetalheRecebimento = useCallback(() => {
		setModalDetalheRecebimento((oldValue) => !oldValue);
	}, []);

	useEffect(() => {
		authentication(user.dados.user_id);
	}, []);

	return (
		<Container fluid>
			<SubHeader />
			{user.dados.tipo_cliente === 'grupo' && <FiltroBar />}
			<Row>
				{recebimentosCard.split.parent && (
					<Col lg="1" className="d-flex align-self-stretch">
						<Card className="w-100">
							<CardSplit
								dadosSplit={recebimentosCard.split}
								porcentagem={70}
								porcentagemSaldo={30}
								subtitulo={{
									texto: 'Hoje',
									weight: 'bold',
									color: 'white',
								}}
								loading={
									transacoes.hoje.loading ||
									transacoes.ontem.loading
								}
							/>
						</Card>
					</Col>
				)}
				<Col
					lg={recebimentosCard.split.parent ? '3' : '4'}
					className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 0 10px 0' }}>
						{retornErrorTransacoesHojeOntem() ? (
							<CardDashError
								error={
									transacoes.hoje.error ||
									transacoes.ontem.error
								}
							/>
						) : (
							<CardPrimeDash
								bgcolor="yellow"
								splitParent={recebimentosCard.split.parent}
								dadosSplit={recebimentosCard.split}
								titulo={{
									texto: 'Total de vendas',
									weight: 'bold',
								}}
								subtitulo={{
									texto: 'Hoje',
									weight: 'bold',
								}}
								valorAtual={verificaNumero(
									transacoes.hoje.dados.total_geral
								)}
								valorOntem={verificaNumero(
									transacoes.ontem.dados.total_geral
								)}
								porcentagem={verificaPorcentagem(
									transacoes.hoje.dados.total_geral,
									transacoes.ontem.dados.total_geral
								)}
								loading={
									transacoes.hoje.loading ||
									transacoes.ontem.loading
								}
							/>
						)}
					</Card>
				</Col>
				<Col md={6} lg={2} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 10px 10px 10px' }}>
						{retornErrorTransacoesHojeOntem() ? (
							<CardDashError
								error={
									transacoes.hoje.error ||
									transacoes.ontem.error
								}
							/>
						) : (
							<CardDash
								bgcolor="softBlack"
								style={{ borderRadius: '0 10px 10px 10px' }}
								titulo={{
									texto: 'Débito',
									weight: 'bold',
									color: 'white',
								}}
								subtitulo={{
									texto: 'Hoje',
									weight: 'bold',
									color: 'white',
								}}
								valorAtual={verificaNumero(
									transacoes.hoje.dados.total_debito
								)}
								valorOntem={verificaNumero(
									transacoes.ontem.dados.total_debito
								)}
								porcentagem={verificaPorcentagem(
									transacoes.hoje.dados.total_debito,
									transacoes.ontem.dados.total_debito
								)}
								loading={
									transacoes.hoje.loading ||
									transacoes.ontem.loading
								}
								tag
							/>
						)}
					</Card>
				</Col>
				<Col md={6} lg={2} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 10px 10px 10px' }}>
						{retornErrorTransacoesHojeOntem() ? (
							<CardDashError
								error={
									transacoes.hoje.error ||
									transacoes.ontem.error
								}
							/>
						) : (
							<CardDash
								bgcolor="softBlack"
								style={{ borderRadius: '0 10px 10px 10px' }}
								titulo={{
									texto: 'Crédito à vista',
									weight: 'bold',
									color: 'white',
								}}
								subtitulo={{
									texto: 'Hoje',
									weight: 'bold',
									color: 'white',
								}}
								valorAtual={verificaNumero(
									transacoes.hoje.dados.total_credito
								)}
								valorOntem={verificaNumero(
									transacoes.ontem.dados.total_credito
								)}
								porcentagem={verificaPorcentagem(
									transacoes.hoje.dados.total_credito,
									transacoes.ontem.dados.total_credito
								)}
								loading={
									transacoes.hoje.loading ||
									transacoes.ontem.loading
								}
								tag
							/>
						)}
					</Card>
				</Col>
				<Col md={6} lg={2} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 10px 10px 10px' }}>
						{retornErrorTransacoesHojeOntem() ? (
							<CardDashError
								error={
									transacoes.hoje.error ||
									transacoes.ontem.error
								}
							/>
						) : (
							<CardDash
								bgcolor="softBlack"
								style={{ borderRadius: '0 10px 10px 10px' }}
								titulo={{
									texto: 'Crédito parcelado',
									weight: 'bold',
									color: 'white',
								}}
								subtitulo={{
									texto: 'Hoje',
									weight: 'bold',
									color: 'white',
								}}
								valorAtual={retornaCreditoPrazo(
									transacoes.hoje.dados.total_geral,
									transacoes.hoje.dados.total_debito,
									transacoes.hoje.dados.total_credito
								)}
								valorOntem={retornaCreditoPrazo(
									transacoes.ontem.dados.total_geral,
									transacoes.ontem.dados.total_debito,
									transacoes.ontem.dados.total_credito
								)}
								porcentagem={verificaPorcentagem(
									retornaCreditoPrazo(
										transacoes.hoje.dados.total_geral,
										transacoes.hoje.dados.total_debito,
										transacoes.hoje.dados.total_credito
									),
									retornaCreditoPrazo(
										transacoes.ontem.dados.total_geral,
										transacoes.ontem.dados.total_debito,
										transacoes.ontem.dados.total_credito
									)
								)}
								loading={
									transacoes.hoje.loading ||
									transacoes.ontem.loading
								}
								tag
							/>
						)}
					</Card>
				</Col>
				<Col md={6} lg={2} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 10px 10px 10px' }}>
						{retornErrorTransacoesHojeOntem() ? (
							<CardDashError
								error={
									transacoes.hoje.error ||
									transacoes.ontem.error
								}
							/>
						) : (
							<CardDash
								bgcolor="softBlack"
								style={{ borderRadius: '0 10px 10px 10px' }}
								titulo={{
									texto: 'Ticket médio',
									weight: 'bold',
									color: 'white',
								}}
								subtitulo={{
									texto: 'Hoje',
									weight: 'bold',
									color: 'white',
								}}
								valorAtual={retornaTicketMedio(
									transacoes.hoje.dados.total_geral,
									transacoes.hoje.dados.total_registros
								)}
								valorOntem={retornaTicketMedio(
									transacoes.ontem.dados.total_geral,
									transacoes.ontem.dados.total_registros
								)}
								porcentagem={verificaPorcentagem(
									retornaTicketMedio(
										transacoes.hoje.dados.total_geral,
										transacoes.hoje.dados.total_registros
									),
									retornaTicketMedio(
										transacoes.ontem.dados.total_geral,
										transacoes.ontem.dados.total_registros
									)
								)}
								loading={
									transacoes.hoje.loading ||
									transacoes.ontem.loading
								}
								tag
							/>
						)}
					</Card>
				</Col>
			</Row>
			<Row>
				<Col md={6} lg={3}>
					<Card
						className="w-100"
						style={{ borderRadius: '10px 10px 0 0' }}>
						{transacoes.dias30.error !== null ? (
							<CardDashError error={transacoes.dias30.error} />
						) : (
							<CardDash
								bgcolor="white"
								style={{ borderRadius: '10px 10px 0 0' }}
								titulo={{
									texto: 'Vendas acumuladas',
									weight: 'bold',
								}}
								subtitulo={{
									texto: '30 dias',
									color: 'gray',
								}}
								valorAtual={transacoes.dias30.dados.total_geral}
								loading={transacoes.dias30.loading}
							/>
						)}
					</Card>
					<Card style={{ borderRadius: '0 0 10px 10px' }}>
						{modalidade.error !== null ? (
							<CardDashError error={modalidade.error} />
						) : (
							<CardBody>
								<div className="d-flex justify-content-between">
									<Text weight="bold" size="small">
										Modalidade mais utilizada
									</Text>
									<Text size="small">30 dias</Text>
								</div>
								<GraficoModalidade
									data={modalidade.lista}
									loading={modalidade.loading}
								/>
							</CardBody>
						)}
					</Card>
				</Col>
				<Col md={6} lg={6} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 0 10px 0' }}>
						{graficoEvolutivo.error !== null ? (
							<CardDashError error={recebimentosCard.error} />
						) : (
							<CardBody>
								<Text weight="bold" size="small">
									Gráfico Evolutivo
								</Text>
								<GraficoEvolutivo
									data={graficoEvolutivo.lista}
									loading={graficoEvolutivo.loading}
								/>
							</CardBody>
						)}
					</Card>
				</Col>
				<Col md={6} lg={3} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 0 10px 10px' }}>
						{transacoes.hoje.error !== null ? (
							<CardDashError error={recebimentosCard.error} />
						) : (
							<CardBody>
								<Text weight="bold" size="small">
									Recebimentos
								</Text>
								<TabelaRecebimentos
									lista={recebimentosCard.lista}
									loading={recebimentosCard.loading}
									handlerDetalheRecebimento={
										setDetalheRecebimento
									}
									toggleModalDetalheRecebimento={
										toggleModalDetalheRecebimento
									}
								/>
							</CardBody>
						)}
					</Card>
				</Col>
				<Col md={6} lg={4} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 0 10px 10px' }}>
						{transacoes.hoje.error !== null ? (
							<CardDashError error={transacoes.hoje.error} />
						) : (
							<CardBody>
								<div className="d-flex justify-content-between">
									<Text weight="bold" size="small">
										Últimas vendas
									</Text>
								</div>
								<TabelaUltimasVendas
									lista={ultimasTransacoes.lista}
									loading={ultimasTransacoes.loading}
									handlerUltimaVenda={setUltimaVenda}
									toggleModalDetalheVenda={
										toggleModalDetalheVenda
									}
								/>
							</CardBody>
						)}
					</Card>
				</Col>
				<Col md={6} lg={4} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 0 10px 10px' }}>
						{bandeiras.error !== null ? (
							<CardDashError error={bandeiras.error} />
						) : (
							<CardBody>
								<div className="d-flex justify-content-between">
									<Text weight="bold" size="small">
										Bandeiras mais utilizadas
									</Text>
									<Text size="small">30 dias</Text>
								</div>
								{/* <BandeiraNome cartao={bandeiras.lista} /> */}
								<GraficoBandeira
									data={bandeiras.lista}
									loading={bandeiras.loading}
								/>
							</CardBody>
						)}
					</Card>
				</Col>
				<Col md={6} lg={4} className="d-flex align-self-stretch">
					<Card
						className="w-100"
						style={{ borderRadius: '0 0 10px 10px' }}>
						{topDias.error !== null ? (
							<CardDashError error={topDias.error} />
						) : (
							<CardBody>
								<Text weight="bold" size="small">
									Top dias de vendas
								</Text>
								<GraficoTopDias
									data={topDias.lista}
									loading={topDias.loading}
								/>
							</CardBody>
						)}
					</Card>
				</Col>
			</Row>

			<ModalDetalheVenda
				toggle={toggleModalDetalheVenda}
				venda={ultimaVenda}
				isOpen={modalDetalheVenda}
			/>

			<ModalDetalheRecebimento
				toggle={toggleModalDetalheRecebimento}
				recebimento={detalheRecebimento}
				isOpen={modalDetalheRecebimento}
			/>
		</Container>
	);
}

export default DashboardWeb;
